import { ChertoExperiments } from 'constants/experiments'
import { useLocation } from 'react-router-dom'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import useExperiment from './useExperiment'
import { useContext } from 'react'
import SearchTilePricingColumnContext from 'components/SearchKit/SearchTiles/SearchTilePricingColumnContext'
import { useCroMobileCompactSearchTileAudience } from 'hooks/Search/useCroMobileCompactSearchTileExperiment'

// CRO-7023: excluded accommodation products share the search list with treatments.
// Align their existing prices without enrolling them or changing their presentation.
// Search-style tiles are reused on other pages, so the route check is intentional.
// Mobile retains each component's original alignment, including for treatments.
export default function useHotelSearchPriceAlignment(): boolean {
  const { pathname } = useLocation()
  const isTabletOrLarger = useScreenSizeUp('tablet')
  const hasPricingColumn = useContext(SearchTilePricingColumnContext)
  const isCompactSearchFunnel = useCroMobileCompactSearchTileAudience()
  const { isAnyVariant } = useExperiment(ChertoExperiments.croOfferTilePriceBlock, { canActivate: false })
  return !isCompactSearchFunnel && hasPricingColumn && isTabletOrLarger && isAnyVariant && !!matchLocaleAwarePath(pathname, { path: '/:regionCode/search', exact: true })
}
